<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование Должности
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs6>
                <TitleTextField
                  v-model="title"
                  :required="true"
                  :rules="[rules.required, rules.min]"
                  label="Наименование*"
                  class="mx-2 mb-3"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs6>
                <MultipleEnumSelect
                  v-model="roles"
                  class="mx-2 mb-3"
                  label="Роли"
                  resource="employee-roles"
                  :return-object="true"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-btn
            small
            color="primary"
            :disabled="!(isValid && isChanged) || isRemoved || loading"
            @click="submit(false)"
          >
            Сохранить
          </v-btn>
          <v-btn
            v-if="!isModal"
            small
            color="primary"
            :disabled="!(isValid && isChanged) || isRemoved || loading"
            @click="saveAndClose"
          >
            Сохранить и закрыть
          </v-btn>
          <v-btn
            small
            @click="cancel"
          >
            Отмена
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="id!==0"
            small
            :color="isRemoved ? 'success' :'error'"
            @click="changeRemovedState"
          >
            {{ isRemoved ? "Восстановить" : "Удалить" }}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
import * as positionsApi from "../../backend/positionsApi.js";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";

export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      isValid: false,
      isChanged: false,
      rules: {
        empty: (v) => !!v || "",
        required: (v) => !!v || "Поле обязательно к заполнению",
        min: (v) =>
          v.length >= 3 || "Поле должно содержать не менее 3-х символов",
      },
      resource: "positions",
      addMessage: "Должность добавлена",
      editMessage: "Должность изменена",
      title: "",
      roles: [],
      isRemoved: false,
      loading: false,
    };
  },
  computed: {
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
  },
  created() {
    if (+this.id) {
      this.getData();
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      const res = await positionsApi.getPosition(this.resource, this.id);
      this.title = res.data.Title;
      this.roles = res.data.Roles.map((r) => {
        return {
          id: r.Id,
          title: r.Title,
        };
      });
      this.isRemoved = res.data.IsRemoved;
    },
    async submit(closeAfterSubmit) {
      const roleIds = [];
      if (this.roles != null) {
        this.roles.map((r) => roleIds.push(r.id));
      }
      const position = {
        title: this.title,
        roleIds,
      };

      if (this.id && this.id > 0) {
        this.loading = true;
        await positionsApi.updatePosition(this.resource, this.id, position);
        this.showInfo(this.editMessage);
        this.isChanged = false;
        this.loading = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        this.getData();
      } else {
        this.loading = true;
        const res = await positionsApi.createPosition(this.resource, position);
        this.showInfo(this.addMessage);
        this.isChanged = false;
        this.loading = false;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", res.data);
        } else {
          this.$router.replace(`/${this.resource}/${res.data}`);
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
        }
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      this.$router.go(-1);
    },
    async saveAndClose() {
      await this.submit(true);
    },
    async changeRemovedState() {
      await positionsApi.changeRemovedState(
        this.resource,
        this.id,
        this.isRemoved,
      );
      this.isRemoved = !this.isRemoved;
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
